import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppInjector } from '@hub/common/app-injector.service';
import { googleAnalyticsHeadScripts } from '@hub/common/google-analytics/GoogleAnalytics';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

googleAnalyticsHeadScripts();

platformBrowserDynamic()
.bootstrapModule(AppModule)
.then((moduleRef) => {
  AppInjector.setInjector(moduleRef.injector);
})
.catch(err => console.log(err));
